import { Injectable, DestroyRef, inject, signal, computed } from '@angular/core';
import { Subject, Subscription, timer } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const BLOCK_TIMEOUT_MS = 5 * 60 * 1000;

@Injectable({ providedIn: 'root' })
export class CommsStatusService {
  private readonly destroyRef = inject(DestroyRef);

  private readonly _errorSince = signal<number | null>(null);
  readonly isBlocked = signal(false);

  private readonly _resumeSubject = new Subject<void>();
  readonly resume$ = this._resumeSubject.asObservable();

  readonly isInError = computed(() => this._errorSince() !== null);

  private blockTimer: Subscription | null = null;

  onSuccess(): void {
    if (this._errorSince() === null && !this.isBlocked()) return;
    this._errorSince.set(null);
    this.isBlocked.set(false);
    this.blockTimer?.unsubscribe();
    this.blockTimer = null;
  }

  onError(): void {
    if (this._errorSince() !== null) return;
    this._errorSince.set(Date.now());
    this.blockTimer = timer(BLOCK_TIMEOUT_MS)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        if (this._errorSince() !== null) {
          this.isBlocked.set(true);
        }
      });
  }

  resume(): void {
    this.isBlocked.set(false);
    this._errorSince.set(null);
    this.blockTimer?.unsubscribe();
    this.blockTimer = null;
    this._resumeSubject.next();
  }
}
